goog.module('yext.developerapps.tableauconnector.ConfigureWDC');
goog.module.declareLegacyNamespace();

const routes = goog.require('yext.developerapps.routes');
const ConfigureSchema = goog.require('yext.developerapps.tableauconnector.ConfigureSchema');
const DataRequestor = goog.require('yext.developerapps.tableauconnector.DataRequestor');
const AjaxActions = goog.require('yext.developerapps.tableauconnector.AjaxActions');
const ReportSelector = goog.require('yext.developerapps.tableauconnector.ReportSelector');
const ConnectionData = goog.require('yext.developerapps.tableauconnector.ConnectionData');


/**
 * @constructor
 */
const ConfigureWDC = function() {
  var ajaxActions = new AjaxActions();
  var connectionData = new ConnectionData();
  var reportSelector = new ReportSelector();

  var BASE_URL = ajaxActions.getAppUrl();
  var WDC_URL = ajaxActions.getWdcUrl();
  var OAUTH_URL = ajaxActions.getOauthURL();
  var clientId = ajaxActions.getClientId();

  var schema;

  const CONFIG = {
    clientId: clientId,
    redirectUri: BASE_URL + '/authcallback',
    authUrl: OAUTH_URL,
  };

  // This one is hardcoded to PROD. To test, we'll need to setup a similar
  // dev version and update the client id to point to that
  const NO_REVIEWS_ACCESS_CONFIG = {
    clientId: '3745389b0ef24abdb7cf09aa50fa6a23',
    redirectUri: BASE_URL + '/noReviewsAccessCallback',
    authUrl: OAUTH_URL,
  };

  // -------------------------------Connector Functions---------------------------//

  /* Create the connector object */
  var myConnector = tableau.makeConnector();

  /* Initialize Connector, set auth, bind options from connectionData */
  myConnector.init = function(initCallback) {
    tableau.authType = tableau.authTypeEnum.custom;

    ajaxActions.logMessage('Phase: ' + tableau.phase);

    /* Set connectionData object if already defined, otherwise use default settings */
    ajaxActions.logMessage('ConnectionData: ' + tableau.connectionData);
    if (tableau.connectionData) {
      connectionData.set(JSON.parse(tableau.connectionData));
    } else {
      connectionData.setDefault();
    }

    /* Check password and initialize schema and in gatherData phase */
    if (tableau.phase == tableau.phaseEnum.gatherDataPhase) {
      if (!tableau.password || tableau.password.length == 0) {
        ajaxActions.logMessage('No password in gatherData phase, aborting for auth');
        tableau.abortForAuth();
      } else if (ajaxActions.checkValidToken(tableau.password)) {
        ajaxActions.setToken(tableau.password);
        schema = new ConfigureSchema(ajaxActions);
      } else {
        tableau.abortWithError('Yext Account does not have valid access token. Please retry ' +
            'connecting to Web Data Conector or contact Yext support.');
      }
    }

    initCallback();

    /* Set up and display report selection options in interactivePhase */
    if (tableau.phase == tableau.phaseEnum.authPhase || tableau.phase == tableau.phaseEnum.interactivePhase) {
      reportSelector.init(connectionData);
    }
  };

  /* Define the schema */
  myConnector.getSchema = function(schemaCallback) {
    ajaxActions.logMessage('Defining Schema');
    var selectedTables = ['metrics', 'bing_searches', 'search', 'reviews', 'facebook_listings',
      'google_listings', 'new_google_listings', 'google_phone', 'listings', 'pages', 'profiles',
      'reviews_analytics', 'searches', 'searches_clicks',
      'search_case_deflection', 'google_listing_actions',
      'google_search_keyword_impressions', 'total_listings_impressions',
      'google_calls_analytics'];
    var allTables = schema.getTables(selectedTables);
    schemaCallback(allTables, schema.standardConnections);
  };

  /* Download the data */
  myConnector.getData = function(table, doneCallback) {
    var dataRequestor = new DataRequestor(ajaxActions, schema, connectionData.getJson());
    ajaxActions.logMessage('Inside myConnector.getData function for: ' + table['tableInfo'].id);
    ajaxActions.logMessage('connectionData: ' + JSON.stringify(connectionData.getJson()));
    try {
      var rows = dataRequestor.getData(table['tableInfo'].id);
      ajaxActions.logMessage('Successfully processed # rows: ' + rows.length);
      table.appendRows(rows);
    } catch (err) {
      ajaxActions.logMessage('Error encountered: ' + err);
    }

    doneCallback();
  };

  ajaxActions.logMessage('Registering connector');
  tableau.registerConnector(myConnector);

  // -------------------------------Connector UI---------------------------//

  function submitConnector() {
    tableau.log('connectionData: ' + JSON.stringify(connectionData.getJson()));
    tableau.log('Button click registered!');

    try {
      if (connectionData.isDateRange('custom')) {
        var startDate = $('#from').val();
        var endDate = $('#to').val();
        connectionData.setCustomDates(startDate, endDate);
        connectionData.validateCustomDates();
      } else {
        connectionData.setCustomDates('', '');
      }

      tableau.connectionData = JSON.stringify(connectionData.getJson());
      tableau.connectionName = 'Yext Data Connection';

      var accessToken = ajaxActions.getCookieToken();
      var hasAuth = (accessToken && accessToken.length > 0) || tableau.password.length > 0;

      if (hasAuth) {
        tableau.password = accessToken;
      }

      tableau.submit();
    } catch (err) {
      reportSelector.showGenericError(err);
    }
  }

  function doAuthRedirect() {
    var url = CONFIG.authUrl + '?response_type=code&client_id=' + CONFIG.clientId +
              '&redirect_uri=' + CONFIG.redirectUri;
    window.location.href = url;
  }

  function doNoReviewsAccessAuthRedirect() {
    var url = NO_REVIEWS_ACCESS_CONFIG.authUrl + '?response_type=code&client_id=' + NO_REVIEWS_ACCESS_CONFIG.clientId +
              '&redirect_uri=' + NO_REVIEWS_ACCESS_CONFIG.redirectUri;
    window.location.href = url;
  }


  function clearCookies() {
    var success = ajaxActions.clearCookies();
    if (success) {
      window.location.href = WDC_URL;
    }
  }

  $(document).ready(function() {
    $('#connectButton').click(function() {
      doAuthRedirect();
    });
    $('#noReviewsAccessConnectButton').click(function() {
      doNoReviewsAccessAuthRedirect();
    });
    $('#submitButton').click(function() {
      submitConnector();
    });
    $('#cancelButton').click(function() {
      window.close();
    });
    $('#resetLogin').click(function() {
      clearCookies();
    });
  });
};

goog.exportSymbol('yext.developerapps.tableauconnector.ConfigureWDC', ConfigureWDC);

exports = ConfigureWDC;
